import React from 'react'
import { Router, Switch } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import PublicRoute from './PublicRoute'
import PrivateRoute from './PrivateRoute'

import Index from '../wizard/components/IndexView'
import Install from '../wizard/components/InstallView'
import Finish from '../wizard/components/FinishView'
import Help from '../wizard/components/HelpView'

const history = createBrowserHistory()
const AppRouter = () => (
    <Router history={history}>
        <Switch>
            <PublicRoute path="/" exact={true} component={Index} history={history} />
            <PublicRoute path="/help" exact={true} component={Help} history={history} />
            <PublicRoute path="/index.html" component={Index} history={history} />
            <PrivateRoute path="/install" component={Install} history={history} />
            <PrivateRoute path="/finish/:errorMessage?" component={Finish} history={history} />
        </Switch>
    </Router>
)

export default AppRouter